import { makeStyles } from '@material-ui/styles';

import { blue, neutral, teal } from 'shared/styles/colors';

import { Color, SwitchModeIOSProps } from './switchModeIOS.model';

const COLOR = {
  primary: teal['50'],
  secondary: blue['50'],
} as Record<Color, string>;

export default makeStyles({
  container: {
    height: '1.5rem',
  },
  label: ({ color, checked = false }: Props) => ({
    position: 'relative',
    width: '2.5rem',
    height: '1.5rem',
    display: 'inline-block',
    cursor: 'pointer',
    borderRadius: '1rem',
    backgroundColor: checked ? COLOR[color] : neutral['50'],
    transition: 'background-color 0.2s',
    '&::before': {
      content: '""',
      position: 'absolute',
      top: '2px',
      left: '2px',
      width: '1.25rem',
      height: '1.25rem',
      borderRadius: '50%',
      backgroundColor: neutral['10'],
      transition: 'transform 0.2s',
      transform: checked ? 'translateX(1rem)' : 'none',
    },
    '&[data-is-disabled="true"]': {
      cursor: 'not-allowed',
      backgroundColor: neutral[30],
    },
  }),
  checked: {
    display: 'none',
  },
});

interface Props {
  color: Color;
  checked?: SwitchModeIOSProps['checked'];
}
